import { render } from "./ModalDefault.vue?vue&type=template&id=5345921f"
import script from "./ModalDefault.vue?vue&type=script&lang=js"
export * from "./ModalDefault.vue?vue&type=script&lang=js"

import "./ModalDefault.vue?vue&type=style&index=0&id=5345921f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__